<template>
  <div>
    <div v-if="tour.label !== 'Moova'">
      {{tour.label}}
    </div>
    <div v-else>
      <img src="/static/img/moova-blue.svg" class="d-block mt-1" style="max-width: 100px;" alt="">
    </div>

    <div v-for="(item, index) in tour.shipping_sizes" :key="index">
      <b-badge class="mr-1" variant="dark">{{index}}</b-badge>
      <span
        v-translate="{count: item}"
        :translate-n="item"
        translate-plural="%{ count } shipments"
      >%{ count } shipment
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToursListItemLabel',
  props: {
    tour: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>
